// extracted by mini-css-extract-plugin
module.exports = {"container":"Date__container___1-utS","time":"Date__time___3nRu_","timeZone":"Date__timeZone___1kgC9"};